import gql from 'graphql-tag';

export default gql`
  mutation AddQuickMeal($input: DailyTrackerAddQuickMealInputType!) {
    dailyTracker {
      addQuickMeal(input: $input) {
        ... on DailyTrackerAddQuickMealSuccess {
          meal {
            id
            isQuickMeal
            isUserMeal
          }
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
